const useGetIsImage = (downloadUrl) => {
  if (!downloadUrl || downloadUrl === '') return false
  const splitData = downloadUrl.split('.')
  const extension = splitData[splitData.length - 1].toLowerCase()
  return extension != 'pdf'
}

export default useGetIsImage
